export default __webpack_public_path__ + "static/media/Photoshop.20f76c56.png";